import { render } from "./TarotDetailHeaderBar.vue?vue&type=template&id=4b2fb7ee&scoped=true"
import script from "./TarotDetailHeaderBar.vue?vue&type=script&lang=js"
export * from "./TarotDetailHeaderBar.vue?vue&type=script&lang=js"

import "./TarotDetailHeaderBar.vue?vue&type=style&index=0&id=4b2fb7ee&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2fb7ee"]])

export default __exports__